export type FilterGroupTitle =
  | 'Tillverkare'
  | 'Abonnemang'
  | 'Delbetalning'
  | 'Skick'
  | 'Begagnat skick'
  | 'Kategorier';

export type FilterLookup = Partial<{
  [filterGroupName in FilterGroupTitle]: { [filterId: string]: string };
}>;

export type Filter = {
  filterId: string;
  name: string;
  default?: boolean;
  isFeatured?: boolean;
  isAlternative?: boolean;
  linkUrl?: string;
  iconName?: string;
};

export type FilterGroupType = 'radio' | 'checkbox';

export type FilterGroup = {
  title: FilterGroupTitle;
  type?: FilterGroupType;
  description: string;
  filters?: Filter[];
  alternateTitle?: string;
};

export const SortModes = [
  'Populärast',
  'Lägst pris',
  'Högst pris',
  'Nyast',
  'Namn A - Ö',
  'Namn Ö - A',
] as const;

export type SortMode = (typeof SortModes)[number];
